import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPdf = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width={32}
    height={32}
    fill='none'
    {...props}
  >
    <rect width={32} height={32} fill='url(#pdf_svg__a)' rx={6} />
    <defs>
      <pattern id='pdf_svg__a' width={1} height={1} patternContentUnits='objectBoundingBox'>
        <use xlinkHref='#pdf_svg__b' transform='matrix(.00068 0 0 .00068 .093 0)' />
      </pattern>
      <image
        xlinkHref='/images/icons/pdf-c78ebdbc.webp'
        id='pdf_svg__b'
        width={1200}
        height={1476}
        preserveAspectRatio='none'
      />
    </defs>
  </svg>
);
export default SvgPdf;
